import type { ExtendedWretchError } from '@/modules/query-client/types/ExtendedWretchError';
import type { WretchInstance } from '@/modules/query-client/types/WretchInstance';
import { merge } from 'lodash-es';
import { WretchError } from 'wretch/resolver';

/**
 * Extend the WretchError with the request
 * @param error - The original WretchError
 * @param request - The original request
 * @returns The extended WretchError with the request
 */
export default function extendWretchError(
  error: WretchError,
  request: WretchInstance
): ExtendedWretchError {
  return merge(error, { request, isExtended: true });
}
